import * as React    from 'react';
import { MenuGroup } from "@elsa-zku/lib/components/Sidebar";

const menu: MenuGroup[] = [
  {
    title: 'Каталог услуг',
    items: [
      {
        url:   "/categories",
        title: "Категории и услуги",
        icon:  require("feather-icons/dist/icons/book-open.svg"),
      },
      {
        url:   "/building-services",
        title: "Услуги по домам",
        icon:  require("feather-icons/dist/icons/home.svg"),
      },
    ]
  },
  {
    title: 'Коммерция',
    items: [
      {
        url:   "/orders",
        title: "Ком. заявки",
        icon:  require("feather-icons/dist/icons/edit.svg"),
      },
      {
        url:   "/passes",
        title: "Пропуска",
        icon:  require("feather-icons/dist/icons/key.svg"),
      },
    ]
  }

];

export default menu;
